module.exports = __webpack_public_path__ + "img/8.d2c893f5.png";